module.exports = __webpack_public_path__ + "static/media/edit.b8d169a7.svg";